import { useEffect, useState } from "react"
import { useLocation, useOutlet } from "react-router-dom"

type FrozenOutletProps = {
  step: string
  stepFromPath: (pathname: string) => string
}

/** Outlet snapshot for the wizard's slide: the exiting step keeps its own screen, while the current step follows redirects that land on the same step key (index → service). */
export function FrozenOutlet({ step, stepFromPath }: FrozenOutletProps) {
  const outlet = useOutlet()
  const { pathname } = useLocation()
  const [frozen, setFrozen] = useState({ outlet, pathname })

  useEffect(() => {
    if (pathname === frozen.pathname) return
    if (stepFromPath(pathname) !== step) return
    setFrozen({ outlet, pathname })
  }, [outlet, pathname, frozen.pathname, step, stepFromPath])

  return frozen.outlet
}
